<template>
  <div>
    <b-button @click="increase">+</b-button
    ><b-button @click="decrease">-</b-button
    ><b-button @click="reset">0</b-button
    ><b-button @click="scrolltop">scrolltop</b-button
    ><b-button @click="scrollmiddle">scrollmiddle</b-button
    ><b-button @click="scrollbottom">scrollbottom</b-button>
    <lazy-list-display-y
      ref="toto"
      :nb="nb_lines"
      :default_height="21"
      :variable_height_start_pos="variable_height_start_pos"
      :variable_heights="variable_heights"
      class="synaplus-cosmo-h-720"
      @fetch_data="fetch_data"
    >
      <template #default="{nby, height}">
        <hex-viewer-line
          :key="nby"
          v-bind="arguments_for_nb(nby)"
          :style="height"
        ></hex-viewer-line>
      </template>
    </lazy-list-display-y>
  </div>
</template>

<script>
import _ from 'lodash'

import Vue from 'vue'
import { mapGetters } from 'vuex'

import {
  get_dummy_file_size,
  get_dummy_file_data,
} from '@/api/subscriptions.js'
import { justification_enum } from '@/utils.js'
import { lazy_scroll_requester_base } from '@/components/lazy_list_requester.js'

import { subscription_mixin } from '@/components/mixin.js'
import LazyListDisplayY from '@/components/lazy_list_display_y.vue'
import HexViewerLine from '@/components/hex_viewer_line.vue'

// *****************************************************************************

// const expected_size = Math.floor((10 * 1000 * 1000) / 4)
const expected_size = Math.floor(200 * 1000 * 1000 * 16)

class lazy_scroll_hexviewer_requester extends lazy_scroll_requester_base {
  async request_blocks(keys) {
    const requested_keys = _.map(keys, function(x) {
      return parseInt(x, 10)
    })
    const raw_data = new Uint8Array(
      await get_dummy_file_data(expected_size, requested_keys)
    )
    let block_size = raw_data.length / keys.length
    let res = {}
    for (const [index, slot] of keys.entries()) {
      const slot_start = index * block_size
      const slot_stop = slot_start + block_size
      let slot_data = raw_data.slice(slot_start, slot_stop)
      res[slot] = slot_data
    }
    return res
  }
}

// *****************************************************************************

const nb_bytes_per_line = 16
const nb_bytes_per_block = 1024

export default {
  name: 'TestLazyScroller',

  components: {
    LazyListDisplayY,
    HexViewerLine,
  },

  mixins: [subscription_mixin],

  props: [],

  data() {
    return {
      file_size: 0,
      file_data: {},
      variable_height_start_pos: undefined,
      variable_heights: undefined,
      // variable_height_start_pos: 64,
      // variable_heights: [
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      //   16,
      // ],
      cur_pos: [0, 0],
    }
  },

  computed: {
    nb_lines() {
      return Math.floor(
        (this.file_size + nb_bytes_per_line - 1) / nb_bytes_per_line
      )
    },
  },

  beforeCreate() {
    this.$options.my_data_requester = new lazy_scroll_hexviewer_requester()
  },

  beforeMount() {
    this.$options.my_data_requester.initialize(
      this.file_data,
      nb_bytes_per_block / nb_bytes_per_line
    )
  },

  async mounted() {
    let res = await get_dummy_file_size(expected_size)
    this.file_size = res
    this.$options.my_data_requester.reset()
  },

  methods: {
    fetch_data(start, stop) {
      // console.log(start, stop)
      const [cur_start, cur_stop] = this.cur_pos
      if (cur_start !== start || cur_stop !== stop) {
        this.cur_pos = [start, stop]
        this.$options.my_data_requester.update(start, stop)
      }
    },
    arguments_for_nb(nb) {
      const bytes_per_slot = nb_bytes_per_block
      let start = nb * nb_bytes_per_line
      let stop = start + nb_bytes_per_line
      let slot_number = Math.floor(start / bytes_per_slot)
      let relative_start = start % bytes_per_slot
      let relative_stop = relative_start + nb_bytes_per_line
      let bytes = this.file_data[slot_number]
      if (bytes) {
        bytes = bytes.slice(relative_start, relative_stop)
      }
      let unknown = false
      if (!_.isUndefined(this.nb_lines)) {
        unknown = _.isUndefined(bytes) && nb < this.nb_lines
      }
      return {
        bytes,
        start,
        stop,
        unknown,
      }
    },
    increase() {
      this.variable_height_start_pos += 64
    },
    decrease() {
      this.variable_height_start_pos -= 64
    },
    reset() {
      this.variable_height_start_pos = 64
    },
    scrolltop() {
      this.$refs.toto.$options.my_lazy_list_handler.scroll_to_pos(
        1000,
        justification_enum.low
      )
    },
    scrollmiddle() {
      this.$refs.toto.$options.my_lazy_list_handler.scroll_to_pos(
        1000,
        justification_enum.middle
      )
    },
    scrollbottom() {
      this.$refs.toto.$options.my_lazy_list_handler.scroll_to_pos(
        1000,
        justification_enum.high
      )
    },
  },
}
</script>
